/**
 * Whether this page is open on a phone or tablet - where the app may live on
 * the same device, so there is nothing to scan a code with.
 *
 * The user agent, not the screen width: a narrow desktop window still has a
 * phone to scan with, and an iPad that says "Macintosh" is caught by its
 * touch points.
 */
export function isPhoneBrowser(
  nav: Pick<Navigator, 'userAgent' | 'maxTouchPoints'> | undefined =
    typeof navigator === 'undefined' ? undefined : navigator,
  coarsePointer: boolean = typeof matchMedia === 'function' && matchMedia('(pointer: coarse)').matches,
): boolean {
  if (!nav) return false;
  const ua = nav.userAgent || '';
  if (/Android|iPhone|iPad|iPod|Mobile/i.test(ua)) return true;
  // An iPad asking for the desktop site says "Macintosh". Touch points alone
  // are not enough - a Mac can report them - so the main pointer must be a
  // finger as well.
  return /Macintosh/.test(ua) && (nav.maxTouchPoints ?? 0) > 1 && coarsePointer;
}

/** The link that opens the app's link-device screen with this code. */
export function appLinkFor(qrPayload: string): string {
  return `nsibi://link-device?p=${encodeURIComponent(qrPayload)}`;
}
